import { styled } from "../../Theme";

export const StandardButtonStyle = styled.button`
  border-radius: 0.5em;
  border: solid 0.1em ${(props) => props.theme.color.primary};
  background-color: ${(props) => props.theme.color.primary};
  color: #FFFFFF;
  padding: 0.5em;
  font-size: 1.5em;
  cursor: pointer;
  font-family: "Title";
  transition: all 0.3s linear;
  :hover {
    box-shadow: 0px 2px 5px 2px rgba(0, 0, 0, 0.24);
  }
`;
